import {
  ForwardRefExoticComponent,
  ReactNode,
  RefAttributes,
  SVGProps,
} from "react";
import { AppHeader } from "../AppHeader";
import { AppView, IAppViewItem, IAppViewSection } from "../AppView";
import { ButtonProps } from "@ttc3k/trekker";

type AppSidebarProps = {
  Icon: ForwardRefExoticComponent<
    Omit<SVGProps<SVGSVGElement>, "ref"> & RefAttributes<SVGSVGElement>
  >;
  headerTitle: string;
  headerDescription: string;
  primaryButtonCopy?: string;
  primaryButtonProps?: ButtonProps;
  primaryButtonReplacement?: ReactNode;
  secondaryButtonCopy?: string;
  secondaryButtonProps?: ButtonProps;
  viewTitle?: string;
  viewSections?: IAppViewSection[];
  onViewSelectionChange?: (selectedItem: IAppViewItem) => void;
};

export const AppSidebar = ({
  Icon,
  headerTitle,
  headerDescription,
  primaryButtonCopy,
  primaryButtonProps,
  primaryButtonReplacement,
  secondaryButtonCopy,
  secondaryButtonProps,
  viewTitle,
  viewSections,
  onViewSelectionChange,
}: AppSidebarProps) => {
  return (
    <>
      <AppHeader
        Icon={Icon}
        title={headerTitle}
        description={headerDescription}
        primaryButtonCopy={primaryButtonCopy}
        primaryButtonProps={primaryButtonProps}
        primaryButtonReplacement={primaryButtonReplacement}
        secondaryButtonCopy={secondaryButtonCopy}
        secondaryButtonProps={secondaryButtonProps}
      />
      <AppView
        title={viewTitle}
        sections={viewSections}
        onSelectionChange={onViewSelectionChange}
        paddingTop="400"
      />
    </>
  );
};
